import React, { FC, useContext, useState } from 'react';
import Router from 'next/router';
import { Alert, AlertIcon, Box, Flex, Heading } from '@chakra-ui/react';
import useToggle from '../hooks/useToggle';
import VerifyCodeForm from '../components/userAuth/VerifyCodeForm';
import SignUpForm from '../components/userAuth/SignUpForm';
import { AuthStateContext } from '../contexts/AuthContext';
import Page from '../components/Page';

const Register: FC = () => {
  const [error, setError] = useState('');
  const [tmpUser, setTmpUser]: [any, any] = useState({});
  const [confirmEmail, toggleConfirmEmail] = useToggle(false);
  // @ts-ignore
  const { isAuthenticated } = useContext(AuthStateContext as any);

  // console.log('isLoading', isLoading);
  async function onUserRegistered(err: string, user: { username: string; password: string }) {
    if (err) {
      console.error({ action: 'onUserRegistered:error', error: { name: '', message: err } });
      setError(err);
      return;
    }

    setTmpUser(user);
    toggleConfirmEmail();
  }

  function goToAccountPage() {
    // console.log('signed in rerouting');
    Router.push('/dashboard').catch((e) => {
      console.error({ action: 'onLogin:route:error', error: e });
      setError('Could not load account page');
    });
  }

  return (
    <Page
      seoOptions={{
        title: 'Sign Up to Unlock Your Free SmartParse Trial',
        description:
          'Sign up with SmartParse to streamline your data migration process. Experience effortless integration of flat files to APIs with minimal setup.',
        canonical: 'https://smartparse.io/sign-up/'
      }}
      maxW='100%'
      p={0}
      m={0}
    >
      <>
        {isAuthenticated && goToAccountPage()}

        <Flex direction={{ base: 'column', md: 'row' }} overflow='hidden' minH='100vh' height='100%'>
          <Box overflowY='auto' flex='1' pb={{ base: '10', md: '16' }} px={{ base: '6', md: '10' }}>
            <Box maxW='sm' mx='auto'>
              <Box textAlign='center' mb={{ base: '4', md: '6' }}>
                <Heading as='h1' size='xl' fontWeight='extrabold' letterSpacing='tight'>
                  {!confirmEmail && 'Sign up for an account'}
                  {confirmEmail && 'Verify account email'}
                </Heading>
              </Box>

              {/* Errors */}
              {error.length > 0 && (
                <Alert status='error' mb='4' borderRadius='md'>
                  <AlertIcon />
                  {error}
                </Alert>
              )}
              {/* eslint-disable-next-line react/jsx-no-bind */}
              {!confirmEmail ? <SignUpForm callback={onUserRegistered} /> : null}

              {confirmEmail ? <VerifyCodeForm user={tmpUser} /> : null}
            </Box>
          </Box>
        </Flex>
      </>
    </Page>
  );
};

export default Register;
